import React, { Component } from 'react';

import LoadingIndication from '../../common/loading-indicator';
import adminStatsService from '../../../services/admin-stats/admin-stats';
import { Chart } from './bar-chart';

class BarChartInfluencersStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,      
      stats: [],
    };
  }

  componentDidMount() {
    const { beforeXDays, untilXDays } = this.props;

    adminStatsService.getInfluencersConversionDistribution(beforeXDays, untilXDays)
      .then((stats) => {
        stats = stats.map(({ influencer: tag, rate}) => ({tag, [tag]: rate}));

        this.setState(() => {
          return {
            isLoading: false,
            isError: false,
            stats: stats,
            xKeys: stats.map(({tag}) => tag)
          };
        }); 
      })
      .catch(error => {
        console.error('BarChartInfluencersStats::componentDidMount', error);
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndication />;
    }

    if (this.state.isError) return <div>Error</div>;

    const { stats, xKeys } = this.state;


    const statsSeparation = [];
    const tagsPerChart = 6;
    for (let i = 0; i < stats.length; i += tagsPerChart) {
      statsSeparation.push(stats.slice(i, i + tagsPerChart));
    } 

    return (
      <div style={{ margin: '30px 0' }}>

        {
          statsSeparation.map(chartStats => (
            <Chart stats={chartStats} xKeys={chartStats.map(x => x.tag)} />
          ))
        }
      </div>
    );
  }
}

export default BarChartInfluencersStats;
